<div class="page-container">
    <div class="page-header">
        <div class="header-content">
            <h1 class="page-title">Driver Management</h1>
            <p class="page-subtitle">Manage your driver roster and contact information</p>
        </div>
    </div>

    <!-- Loading Spinner -->
    <div *ngIf="isLoading" class="loading-overlay">
        <mat-spinner diameter="50" color="primary"></mat-spinner>
        <p class="loading-text">Loading drivers...</p>
    </div>

    <div class="card" [class.loading]="isLoading">
        <div class="card-header">
            <div class="search-wrapper">
                <mat-icon class="search-icon">search</mat-icon>
                <input
                    type="text"
                    class="search-input"
                    [(ngModel)]="searchText"
                    placeholder="Search by name or phone..."
                />
                <mat-icon *ngIf="searchText" class="clear-icon" (click)="searchText = ''">close</mat-icon>
            </div>

            <button class="btn-primary" (click)="addNewDriver()">
                <mat-icon>add</mat-icon>
                <span>Add Driver</span>
            </button>
        </div>

        <div class="table-container" *ngIf="filteredOrders.length > 0">
            <table class="data-table">
                <thead>
                    <tr>
                        <th>Driver</th>
                        <th>Khmer Name</th>
                        <th>English Name</th>
                        <th>Phone Number</th>
                        <th class="th-actions">Actions</th>
                    </tr>
                </thead>
                <tbody>
                    <tr *ngFor="let data of pagedOrders">
                        <td>
                            <div class="driver-photo">
                                <img [src]="data.driverPicURL" alt="Driver Photo" class="driver-img" />
                            </div>
                        </td>
                        <td>
                            <span class="cell-text">{{ data.khmerName || '—' }}</span>
                        </td>
                        <td>
                            <span class="cell-text">{{ data.englishName || '—' }}</span>
                        </td>
                        <td>
                            <span class="cell-text">{{ data.primaryContactNumber | phoneFormat }}</span>
                        </td>
                        <td class="actions-cell">
                            <button class="btn-icon-action" (click)="editDriver(data, $event)">
                                <mat-icon>more_vert</mat-icon>
                            </button>

                            <div *ngIf="selectedDriverId === data.id" class="dropdown-menu"
                                [style.top]="dropdownPosition.top"
                                [style.right]="dropdownPosition.right">
                                <button class="dropdown-item" (click)="onEdit(data)">
                                    <mat-icon class="dropdown-icon edit-icon">edit</mat-icon>
                                    Edit
                                </button>
                                <div class="dropdown-divider"></div>
                                <button class="dropdown-item dropdown-item-danger" (click)="onDelete(data)">
                                    <mat-icon class="dropdown-icon">delete</mat-icon>
                                    Delete
                                </button>
                            </div>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>

        <div class="empty-state" *ngIf="filteredOrders.length === 0">
            <mat-icon class="empty-icon">person</mat-icon>
            <h3>No drivers found</h3>
            <p>{{ searchText ? 'Try adjusting your search criteria' : 'Get started by adding your first driver' }}</p>
        </div>

        <div class="card-footer" *ngIf="filteredOrders.length > 0">
            <div class="pagination-info">
                Showing <strong>{{ (currentPage - 1) * pageSize + 1 }}</strong> to
                <strong>{{ currentPage * pageSize > filteredOrders.length ? filteredOrders.length : currentPage * pageSize }}</strong>
                of <strong>{{ filteredOrders.length }}</strong> drivers
            </div>

            <div class="pagination">
                <button class="pagination-btn" [disabled]="currentPage === 1" (click)="getDriverList(currentPage - 1)">
                    <mat-icon>chevron_left</mat-icon>
                </button>

                <ng-container *ngFor="let page of pages">
                    <button
                        class="pagination-btn pagination-number"
                        [ngClass]="{ 'active': page === currentPage }"
                        (click)="getDriverList(page)">
                        {{ page }}
                    </button>
                </ng-container>

                <button class="pagination-btn" [disabled]="currentPage === totalPages" (click)="getDriverList(currentPage + 1)">
                    <mat-icon>chevron_right</mat-icon>
                </button>
            </div>
        </div>
    </div>
</div>
